const SvgQuantum1 = (props) => (
  <>
    <path
      d="M183.78 103.73c.08-48.42-39.22-88.05-87.64-88.25-48.42-.2-87.84 39.83-87.92 88.25-.07 41.04 28.24 75.09 66.35 84.64-25.84-8.84-44.46-33.05-44.41-61.88.06-36.31 29.63-66.33 65.94-66.18 36.31.15 65.79 29.87 65.73 66.19-.05 28.86-18.7 53.29-44.58 62.03 38.15-9.35 66.46-43.71 66.52-84.79Z"
      fill={props.p10}
    />
    <path
      d="M96.11 60.17c-36.31-.15-65.88 29.87-65.94 66.18-.06 36.31 29.49 65.33 65.81 65.48 36.31.15 65.8-29.17 65.86-65.48.06-36.31-29.41-66.04-65.73-66.19Zm-.2 131.63c-24.22-.07-43.86-19.76-43.79-43.98.07-24.22 19.83-43.86 44.04-43.79s43.79 19.83 43.72 44.04-19.76 43.79-43.98 43.72Z"
      fill={props.p20}
    />
    <circle cx={96} cy={192} r={4} fill={props.p30} />
    <circle cx={96.16} cy={59.43} r={4} fill={props.p30} />
    <circle cx={96.16} cy={16.05} r={4} fill={props.p30} />
    <circle cx={96.16} cy={103.52} r={4} fill={props.p30} />
  </>
);

export default SvgQuantum1;
